import { color, font, space, type } from "@/lib/design-tokens";
import { Wrap } from "./primitives";

const INSTAGRAM_HANDLE = "frontrangecargobikes";
const INSTAGRAM_URL = `https://www.instagram.com/${INSTAGRAM_HANDLE}/`;

const POSTS = [
  { shortcode: "DTUMGX4DNGW", image: "/images/instagram/post-DTUMGX4DNGW.jpg", alt: "A bicycle wheel with damaged spokes in the service shop" },
  { shortcode: "DTBbcOzj67f", image: "/images/instagram/post-DTBbcOzj67f_1.jpg", alt: "An Urban Arrow cargo bike being worked on in the shop" },
  { shortcode: "DSvPnTpj4n_", image: "/images/instagram/post-DSvPnTpj4n_.jpg", alt: "A compact cargo bike parked at Tantra Park in Boulder" },
  { shortcode: "DStYBEBDEJd", image: "/images/instagram/post-DStYBEBDEJd.jpg", alt: "Cargo-bike riders in a nighttime holiday parade" },
  { shortcode: "DR2BVLajgr5", image: "/images/instagram/post-DR2BVLajgr5.jpg", alt: "A Flyer cargo bike parked in fresh snow" },
  { shortcode: "DRzUYYwji9U", image: "/images/instagram/post-DRzUYYwji9U_1.jpg", alt: "A gravel bike overlooking the Flatirons" },
  { shortcode: "DRxCoeSDuaO", image: "/images/instagram/post-DRxCoeSDuaO.jpg", alt: "An Urban Arrow cargo bike under a cloudy sky" },
  { shortcode: "DRkeIzQj9FP", image: "/images/instagram/post-DRkeIzQj9FP.jpg", alt: "A Thanksgiving turkey posed with a bicycle and pumpkins" },
  { shortcode: "DRTXAWhDF3k", image: "/images/instagram/post-DRTXAWhDF3k.jpg", alt: "A cargo bike carrying recyclable packing material to CHaRM" },
  { shortcode: "DFQzmCbSef0", image: "/images/instagram/post-DFQzmCbSef0.jpg", alt: "A yellow longtail cargo bike parked in the snow" },
] as const;

/** Static, locally cached posts: no Meta script, tracking pixel, or API token. */
export function InstagramFeed() {
  return (
    <section data-section="instagram" style={{ background: color.white, borderTop: `1px solid ${color.border}` }}>
      <Wrap padY={space.sectionY}>
        <div data-reveal style={{ display: "flex", flexWrap: "wrap", alignItems: "end", justifyContent: "space-between", gap: "18px 32px", marginBottom: "clamp(28px,4vw,44px)" }}>
          <div>
            <div style={{ fontFamily: font.mono, fontSize: "12px", letterSpacing: ".14em", textTransform: "uppercase", color: color.blue }}>
              Instagram · @{INSTAGRAM_HANDLE}
            </div>
            <h2 style={{ margin: "12px 0 0", fontSize: type.h2, fontWeight: 800, lineHeight: 1.12, color: color.ink }}>
              Bikes, rides, and shop work
            </h2>
          </div>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="bb-arrow-link" style={{ color: color.blue, fontWeight: 800 }}>
            Follow us on Instagram →
          </a>
        </div>

        <div className="bb-instagram-grid">
          {POSTS.map((post) => (
            <a
              key={post.shortcode}
              href={`https://www.instagram.com/p/${post.shortcode}/`}
              target="_blank"
              rel="noopener noreferrer"
              className="bb-instagram-card"
              aria-label={`Open Instagram post: ${post.alt}`}
            >
              <img src={post.image} alt={post.alt} loading="lazy" />
            </a>
          ))}
        </div>
      </Wrap>
    </section>
  );
}
